//CSS
import "../../Components/Page/Page.css";
import "./ElfDemoNews.css";

//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";
import ContentButton from "../../Components/ContentButton/ContentButton";
import { useNavigate } from "react-router-dom";
import BostonIcon from "../../Images/ElfDemo/ElfBostonIcon.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTruck, faCog, faClock } from "@fortawesome/free-solid-svg-icons";

const ElfDemoNews: React.FC = () => {
  const navigate = useNavigate();

  const goToBoston = () => {
    navigate("/boston-elftech-demo-2026");
  };

  return (
    <div className="sectionContainer">
      <SecHeader title="Demo" />
      <SubSection isSplit={false}>
        <ContentButton click={goToBoston}>
          <p>
            <h1>Massachusetts</h1>
          </p>
          <p>
            <h2>ELF-Tech™ Demo</h2>
          </p>
          <p>
            <div className="image-container">
              <div className="image-background">
                <div className="icon-overlap">
                  <FontAwesomeIcon icon={faCog} size="4x" className="icon-back" />
                  <FontAwesomeIcon icon={faClock} size="2x" className="icon-front" />
                </div>
                {/* <img
                  src={BostonIcon}
                  alt="ElfTech Demo Boston"
                  className="boston-image"
                /> */}
              </div>
            </div>
          </p>
          {/* <p>
            <b>October, 2026 Tentative</b>
          </p> */}
        </ContentButton>
      </SubSection>
    </div>
  );
};

export default ElfDemoNews;
